import { createSlice } from "@reduxjs/toolkit";
import { fetchExpenseRecognition } from "./expenseRecognitionThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
    recordType: "without details",
    fromDate: null,
    toDate: null,
  },
};

const expenseRecognitionSlice = createSlice({
  name: "expenseRecognition",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExpenseRecognition.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExpenseRecognition.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchExpenseRecognition.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = expenseRecognitionSlice.actions;
export default expenseRecognitionSlice.reducer;
